import {
    Button,
    Divider,
    Flex,
    Modal,
    Space,
    Table
} from "antd";
import {
    languages
} from "../../utils/languages";
import {
    useContext,
    useEffect,
    useState
} from "react";
import {
    NotificationContext
} from "../../context/notification-provider";
import {
    useMutation,
    useQuery
} from "@apollo/client";
import {
    ExclamationCircleFilled
} from '@ant-design/icons';
import {
    RETRIEVE_TYPE_PRICES
} from "../../apollo/query/prices.query";
import {
    DELETE_TYPE_PRICE
} from "../../apollo/mutation/prices.mutation";
import PriceTypeDetail from "../../components/price-type-detail";

const { confirm } = Modal;

const PricesTypes = () => {
    /** State to manage the visibility of the price detail */
    const [visible, setVisible] = useState<number | null>(null);
    /** Notification utilities */
    const { showNotification } = useContext(NotificationContext);
    /** Request the list of price */
    const { data } = useQuery(RETRIEVE_TYPE_PRICES);
    /** Request the deletion of the price */
    const [ deleteCategory, { data: responseDeletion } ] = useMutation(DELETE_TYPE_PRICE, { refetchQueries: ['gqlRetrieveTypePrices']} );
 
    /** Manage to display the alert of deletion succeed */
    useEffect((): void => {
        if( responseDeletion?.code === 200 ) {
            showNotification({ severity: 'success', title: 'Tipus de preu eliminat.' });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseDeletion]);
 
    /** Manage to delete the specific subcategory */
    const onDelete = (sNameKey: string): void => {
        confirm({
            title: 'Estàs segur d\'eliminar aquest tipus de preu?',
            icon: <ExclamationCircleFilled />,
            okText: 'Confirmar',
            onOk() {
                deleteCategory({ variables: { sNameKey: sNameKey } });
            },
            cancelText: 'Cancel·lar'
        });
    }
 
    const columns = [
        {
            title: 'Tipus de preu [Català]',
            dataIndex: 'ca',
            key: 'ca',
            render: (_: string, record: any) => <span> { record.languages['ca'] } </span>
        },
        ...languages.map((lang: any) => ({
            title: `${lang.label}`,
            dataIndex: lang.value,
            key: lang.valye,
            render: (_: string, record: any) => <span> { record.languages[lang.value] } </span>
        })),
        {
            title: 'Accions',
            key: 'action',
            render: (_: any, record: any) => (
                <Space size="middle">
                    {/* eslint-disable-next-line eqeqeq */}
                    <Button type='text' danger disabled={record.nID == 1} onClick={(evt: any) => {
                        onDelete(record.sNameKey);
                        evt.stopPropagation();
                    }}> Eliminar </Button>
                </Space>
            )
        }
    ];

    return (
        <Flex vertical style={{ backgroundColor: 'white', height: '100%', padding: 10 }}>
            <Flex justify='flex-end'>
                <Button type='primary' onClick={() => setVisible(-1)}> Afegir tipus de preu </Button>
            </Flex>
            <Divider />
            <Flex style={{ width: '100%' }}>
                <Table
                    columns={columns}
                    dataSource={[...(data?.data ?? [])].sort((a: any, b: any) => a.languages['ca'] < b.languages['ca'] ? -1 : 1)}
                    rowKey={(record: any) => record.nID}
                    style={{ width: '100%' }}
                    onRow={(record) => {
                        return {
                            onClick: () => setVisible(record.nID)
                        };
                    }}
                    pagination={false}
                />
            </Flex>
            <PriceTypeDetail id={visible} visible={visible} setVisible={setVisible} />
        </Flex>
    );
}

export default PricesTypes;